import { FC } from "react";
import { FormControl } from "@mui/material";
import { styled } from "@mui/system";
import { H5, Span } from "../Typography";

const StyledForm = styled("form")(() => ({
  width: "100%",
}));

const InputBox = styled(FormControl)(() => ({
  width: "100%",
  margin: "8px 0px",
}));

const styleObj = {
  margin: "10px 0px",
  width: "100%",
  padding: ".6rem .8rem",
  fontSize: ".9rem",
  borderRadius: "5px",
  lineHeight: "1.5",
  border: "none",
  transition: "all .3s",
};

const StyledInput = styled("input")(({ theme }) => ({
  ...styleObj,
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[50]
      : theme.palette.grey[800],
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[300] : "#f5f8fa",
  "&:focus": {
    outline: "none",
    backgroundColor: theme.palette.mode === "light" && "#ecf0f3",
  },
}));

const StyledSelect = styled("select")(({ theme }) => ({
  ...styleObj,
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[50]
      : theme.palette.grey[800],
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[300] : "#f5f8fa",
  "&:focus": {
    outline: "none",
    backgroundColor: theme.palette.mode === "light" && "#ecf0f3",
  },
}));

const TextArea = styled("textarea")(({ theme }) => ({
  ...styleObj,
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[50]
      : theme.palette.grey[800],
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[300] : "#f5f8fa",
  "&:focus": {
    outline: "none",
    backgroundColor: theme.palette.mode === "light" && "#ecf0f3",
  },
}));

const Error = styled(Span)(({ theme }) => ({
  color: theme.palette.error.main,
}));

interface Props {
  handleClose?: any;
  setSuccessModal: (value: boolean) => void;
  register?: any;
  handleSubmit?: any;
  onSubmit?: any;
  errors?: any;
}
const PaymentRecordForm: FC<Props> = (props) => {
  const { register, handleSubmit, onSubmit, errors } = props;

  return (
    <>
      <StyledForm onSubmit={handleSubmit(onSubmit)}>
        <InputBox>
          <H5>
            Invoice Number <Span color="red">*</Span>
          </H5>
          <StyledInput
            placeholder="4576-34985"
            {...register("invoice", { required: true })}
          />
          {errors.invoice && <Error>Invoice Number is required</Error>}
        </InputBox>

        <InputBox>
          <H5>
            Status <Span color="red">*</Span>
          </H5>
          <StyledSelect {...register("status", { required: true })}>
            <option value="" selected disabled hidden>
              Select State
            </option>
            <option value="Bangladesh">Bangladesh</option>
            <option value="India">India</option>
            <option value="Pakistan">Pakistan</option>
          </StyledSelect>
          {errors.status && <Error>Status is required</Error>}
        </InputBox>

        <InputBox>
          <H5>
            Amount of invoice <Span color="red">*</Span>
          </H5>
          <StyledInput
            placeholder="Sylhet"
            {...register("amount", { required: true })}
          />
          {errors.amount && <Error>Amount is required</Error>}
        </InputBox>

        <InputBox>
          <H5>Additional Information</H5>
          <TextArea
            rows="4"
            placeholder="Description"
            {...register("details")}
          />
        </InputBox>
      </StyledForm>
    </>
  );
};

export default PaymentRecordForm;
